module.exports = __webpack_public_path__ + "img/1516194847.5e70b82e.jpg";